import Logout from "../Components/Logout/Logout";

const LogoutPage = () => {
  return <Logout />;
};

export default LogoutPage;
